module.exports = __webpack_public_path__ + "static/media/adsDisplay.938a7b0c.svg";